<template>
  <div class="edit-base-shelf-item">
    <div class="edit-shelfname-label">专辑内作品打开方式</div>
    <div class="poster-open">
      <el-select class="personal-item-select" size="mini" v-model="openMode">
        <el-option v-for="item in posterOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: Object
  },
  data() {
    return {
      posterOptions: [
        {
          value: 0,
          label: '直接打开'
        },
        {
          value: 1,
          label: '新标签页打开'
        }
      ]
    }
  },
  computed: {
    openMode: {
      get: function() {
        let data1 = this.$store.state.config.bookShelfObj.openMode
        let data2 = this.$store.state.config.bookLibObj.openMode
        if (this.type.getType == 'Lib') {
          return data2
        } else {
          return data1
        }
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'OPENMODE', newValue)
      }
    }
  }
}
</script>
